var _circle, _circle2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 4492",
    filter: "url(#filter0_i_345_13761)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#627EEA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 5",
    style: {
      mixBlendMode: "darken"
    },
    filter: "url(#filter1_i_345_13761)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23.9992,
    r: 16.9292,
    stroke: "#181818",
    strokeWidth: 0.815864
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6 (Stroke)",
    filter: "url(#filter2_dd_345_13761)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2668 25.5966C44.5663 25.6199 44.8287 25.396 44.8442 25.096C44.863 24.7329 44.8725 24.3673 44.8725 23.9995C44.8725 23.6317 44.863 23.2661 44.8442 22.903C44.8287 22.603 44.5663 22.3791 44.2668 22.4023L44.1312 22.4129C43.8317 22.4361 43.6086 22.6978 43.6236 22.9978C43.6403 23.3295 43.6487 23.6634 43.6487 23.9995C43.6487 24.3355 43.6403 24.6695 43.6236 25.0012C43.6086 25.3012 43.8317 25.5628 44.1312 25.5861L44.2668 25.5966ZM44.1667 29.4014C44.2442 29.1112 44.0634 28.8175 43.7712 28.7476L43.639 28.716C43.3468 28.6461 43.0541 28.8265 42.9761 29.1166C42.8021 29.7632 42.596 30.3967 42.3595 31.0152C42.2522 31.2958 42.3832 31.6137 42.6606 31.7288L42.7862 31.7809C43.0637 31.8959 43.3826 31.7645 43.4904 31.4841C43.7509 30.8062 43.977 30.1113 44.1667 29.4014ZM41.5088 35.3664C41.6726 35.1146 41.5919 34.7792 41.3359 34.622L41.22 34.5508C40.9641 34.3936 40.6298 34.4742 40.4655 34.7257C40.1006 35.2847 39.7079 35.8241 39.2894 36.3418C39.1006 36.5754 39.1268 36.9183 39.3552 37.1135L39.4585 37.2018C39.6868 37.397 40.0308 37.3706 40.22 37.1373C40.6794 36.5708 41.1098 35.9797 41.5088 35.3664ZM37.1378 40.2195C37.3711 40.0303 37.3975 39.6864 37.2023 39.458L37.1139 39.3547C36.9188 39.1263 36.5759 39.1001 36.3423 39.2889C35.8246 39.7074 35.2852 40.1001 34.7262 40.4651C34.4747 40.6293 34.3941 40.9636 34.5513 41.2195L34.6225 41.3354C34.7797 41.5914 35.115 41.6721 35.3668 41.5083C35.9802 41.1093 36.5712 40.6789 37.1378 40.2195ZM31.4846 43.4899C31.765 43.3822 31.8964 43.0632 31.7814 42.7858L31.7293 42.6601C31.6142 42.3827 31.2963 42.2518 31.0157 42.359C30.3972 42.5955 29.7637 42.8016 29.1171 42.9756C28.827 43.0536 28.6466 43.3463 28.7165 43.6385L28.7481 43.7707C28.818 44.0629 29.1117 44.2437 29.4019 44.1662C30.1118 43.9765 30.8067 43.7504 31.4846 43.4899ZM25.0965 44.8437C25.3965 44.8282 25.6204 44.5658 25.5971 44.2663L25.5866 44.1307C25.5633 43.8312 25.3017 43.6081 25.0017 43.6231C24.67 43.6398 24.336 43.6482 24 43.6482C23.6639 43.6482 23.33 43.6398 22.9983 43.6231C22.6983 43.6081 22.4366 43.8312 22.4134 44.1307L22.4028 44.2663C22.3796 44.5658 22.6035 44.8282 22.9035 44.8437C23.2666 44.8625 23.6322 44.872 24 44.872C24.3678 44.872 24.7333 44.8625 25.0965 44.8437ZM18.598 44.1662C18.8882 44.2437 19.1819 44.0629 19.2518 43.7707L19.2835 43.6385C19.3534 43.3463 19.173 43.0536 18.8829 42.9756C18.2362 42.8016 17.6027 42.5955 16.9843 42.359C16.7037 42.2518 16.3857 42.3827 16.2706 42.6601L16.2186 42.7858C16.1035 43.0632 16.2349 43.3822 16.5153 43.4899C17.1932 43.7504 17.8882 43.9765 18.598 44.1662ZM12.6331 41.5083C12.8849 41.6721 13.2203 41.5914 13.3774 41.3354L13.4486 41.2196C13.6058 40.9636 13.5253 40.6293 13.2737 40.4651C12.7147 40.1001 12.1754 39.7074 11.6577 39.2889C11.424 39.1001 11.0812 39.1263 10.886 39.3547L10.7976 39.458C10.6024 39.6864 10.6288 40.0303 10.8622 40.2195C11.4287 40.6789 12.0197 41.1093 12.6331 41.5083ZM7.77995 37.1373C7.96916 37.3706 8.31308 37.397 8.54141 37.2018L8.64477 37.1135C8.8731 36.9183 8.89934 36.5754 8.7105 36.3418C8.29202 35.8241 7.89933 35.2847 7.53438 34.7257C7.37017 34.4742 7.03587 34.3936 6.77989 34.5508L6.66402 34.622C6.40804 34.7792 6.32735 35.1145 6.49115 35.3663C6.89016 35.9797 7.32051 36.5708 7.77995 37.1373ZM4.50953 31.4841C4.61728 31.7645 4.9362 31.8959 5.21368 31.7809L5.33929 31.7288C5.61677 31.6137 5.74768 31.2958 5.6404 31.0152C5.40391 30.3967 5.1978 29.7632 5.02387 29.1166C4.94585 28.8265 4.65312 28.6461 4.36097 28.716L4.22872 28.7476C3.93658 28.8175 3.75569 29.1112 3.83323 29.4014C4.02289 30.1113 4.24904 30.8062 4.50953 31.4841ZM3.73314 25.5966C3.43365 25.6199 3.17127 25.396 3.15575 25.096C3.13695 24.7329 3.12744 24.3673 3.12744 23.9995C3.12744 23.6317 3.13695 23.2661 3.15575 22.903C3.17127 22.603 3.43365 22.3791 3.73314 22.4023L3.86871 22.4129C4.1682 22.4361 4.39135 22.6978 4.3763 22.9978C4.35966 23.3295 4.35124 23.6634 4.35124 23.9995C4.35124 24.3355 4.35966 24.6695 4.3763 25.0012C4.39135 25.3012 4.1682 25.5628 3.86871 25.5861L3.73314 25.5966ZM3.83323 18.5975C3.75569 18.8877 3.93658 19.1814 4.22872 19.2513L4.36097 19.283C4.65312 19.3529 4.94585 19.1725 5.02387 18.8824C5.1978 18.2357 5.40391 17.6022 5.6404 16.9838C5.74768 16.7032 5.61677 16.3852 5.33929 16.2702L5.21368 16.2181C4.9362 16.103 4.61728 16.2344 4.50953 16.5148C4.24904 17.1927 4.02289 17.8877 3.83323 18.5975ZM6.49115 12.6326C6.32735 12.8844 6.40804 13.2198 6.66402 13.377L6.77989 13.4481C7.03587 13.6053 7.37017 13.5248 7.53438 13.2732C7.89933 12.7142 8.29202 12.1749 8.7105 11.6572C8.89934 11.4235 8.8731 11.0807 8.64477 10.8855L8.54142 10.7971C8.31309 10.6019 7.96916 10.6284 7.77995 10.8617C7.32051 11.4282 6.89016 12.0193 6.49115 12.6326ZM10.8622 7.77946C10.6288 7.96867 10.6024 8.3126 10.7976 8.54093L10.886 8.64428C11.0812 8.87261 11.424 8.89885 11.6577 8.71001C12.1754 8.29153 12.7147 7.89884 13.2737 7.5339C13.5253 7.36968 13.6058 7.03538 13.4486 6.7794L13.3774 6.66353C13.2203 6.40755 12.8849 6.32686 12.6331 6.49067C12.0197 6.88967 11.4287 7.32002 10.8622 7.77946ZM16.5153 4.50904C16.2349 4.61679 16.1035 4.93571 16.2186 5.21319L16.2706 5.3388C16.3857 5.61628 16.7037 5.74719 16.9843 5.63991C17.6027 5.40342 18.2362 5.19731 18.8829 5.02338C19.173 4.94536 19.3534 4.65263 19.2835 4.36048L19.2518 4.22824C19.1819 3.93609 18.8882 3.7552 18.598 3.83274C17.8882 4.02241 17.1932 4.24855 16.5153 4.50904ZM22.9035 3.15526C22.6035 3.17079 22.3796 3.43316 22.4028 3.73265L22.4134 3.86822C22.4366 4.16771 22.6983 4.39086 22.9983 4.37581C23.33 4.35917 23.6639 4.35075 24 4.35075C24.336 4.35075 24.67 4.35917 25.0017 4.37581C25.3017 4.39086 25.5633 4.16771 25.5866 3.86822L25.5971 3.73265C25.6204 3.43316 25.3965 3.17079 25.0965 3.15526C24.7333 3.13647 24.3678 3.12695 24 3.12695C23.6322 3.12695 23.2666 3.13647 22.9035 3.15526ZM29.4019 3.83274C29.1117 3.7552 28.818 3.93609 28.7481 4.22824L28.7165 4.36048C28.6466 4.65263 28.827 4.94536 29.1171 5.02338C29.7637 5.19731 30.3972 5.40342 31.0157 5.63991C31.2963 5.7472 31.6142 5.61628 31.7293 5.3388L31.7814 5.2132C31.8964 4.93571 31.765 4.61679 31.4846 4.50904C30.8067 4.24855 30.1118 4.02241 29.4019 3.83274ZM35.3668 6.49067C35.115 6.32686 34.7797 6.40755 34.6225 6.66353L34.5513 6.7794C34.3941 7.03538 34.4747 7.36968 34.7262 7.5339C35.2852 7.89884 35.8246 8.29153 36.3423 8.71002C36.5759 8.89885 36.9188 8.87262 37.1139 8.64429L37.2023 8.54093C37.3975 8.3126 37.3711 7.96868 37.1378 7.77947C36.5713 7.32003 35.9802 6.88967 35.3668 6.49067ZM40.22 10.8617C40.0308 10.6284 39.6868 10.6019 39.4585 10.7971L39.3552 10.8855C39.1268 11.0807 39.1006 11.4235 39.2894 11.6572C39.7079 12.1749 40.1006 12.7142 40.4655 13.2732C40.6298 13.5248 40.9641 13.6053 41.22 13.4481L41.3359 13.377C41.5919 13.2198 41.6726 12.8844 41.5088 12.6326C41.1098 12.0193 40.6794 11.4282 40.22 10.8617ZM43.4904 16.5148C43.3826 16.2344 43.0637 16.103 42.7862 16.2181L42.6606 16.2702C42.3832 16.3852 42.2522 16.7032 42.3595 16.9838C42.596 17.6022 42.8021 18.2357 42.9761 18.8824C43.0541 19.1725 43.3468 19.3529 43.639 19.283L43.7712 19.2513C44.0634 19.1814 44.2442 18.8877 44.1667 18.5975C43.977 17.8877 43.7509 17.1927 43.4904 16.5148Z",
    fill: "#FAF1EC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0146 10.4697V20.38L32.3909 24.1229L24.0146 10.4697Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.0146 10.4697L15.6372 24.1229L24.0146 20.38V10.4697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.0146 30.546V37.2798L32.3965 25.6836L24.0146 30.546Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.0146 37.2798V30.5449L15.6372 25.6836L24.0146 37.2798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.0146 28.987L32.3909 24.1235L24.0146 20.3828V28.987Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.6372 24.1235L24.0146 28.987V20.3828L15.6372 24.1235Z",
    fill: "white",
    fillOpacity: 0.602
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_345_13761",
    x: 0,
    y: 0,
    width: 48,
    height: 48.5439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.543909
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.951841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.921569 0 0 0 0 0.866667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_345_13761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_345_13761",
    x: 6.66284,
    y: 6.66211,
    width: 34.6743,
    height: 35.2182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.543909
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.271955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.561256 0 0 0 0 0.561256 0 0 0 0 0.561256 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_345_13761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_345_13761",
    x: 2.85549,
    y: 2.855,
    width: 42.289,
    height: 42.8329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.543909
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.135977
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_345_13761"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.271955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_345_13761",
    result: "effect2_dropShadow_345_13761"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_345_13761",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.a61ec14459804e510c15057cdbd4dd33.svg";
export { ForwardRef as ReactComponent };